import {Center} from 'src/design/atoms/Center';
import {Loader} from 'src/design/atoms/Loader';
import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {resolveLinkPath} from './resolveLinkPath';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const LinkRedirectPage = () => {
  const navigate = useAppNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const path = resolveLinkPath(searchParams);
    if (path) {
      navigate(path, {replace: true});
    } else {
      navigate(PathUtility.NotFound(), {replace: true});
    }
  }, [navigate, searchParams]);

  return (
    <Center h="100vh">
      <Loader />
    </Center>
  );
};

routeRegistry.registerRoute({
  backNavigation: 'transient',
  path: PathUtility.LinkRedirect(),
  element: <LinkRedirectPage />,
});

export default LinkRedirectPage;
